import IDsCard from "./IDsCard";

export default IDsCard;
